import { useLocation } from "react-router-dom";
import { useState } from "react";

import { getLoginUserData } from "./_lib.js";

import { AppRoutes } from "./routes";

import AppSidebar from "./components/sidebar/AppSidebar.js";
import { AuthProvider } from "./context/AuthContext";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import "./App.css";
import TrayHistory from "./pages/trays/trayHistory.jsx";
import BranchesList from "./pages/branches/BranchesList.jsx";
import { useEffect } from "react";

function App() {
  const location = useLocation();

  const [collapsed, setCollapsed] = useState(false);
  const [isHovered, setIsHovered] = useState(false);

  const user = JSON.parse(localStorage.getItem("user"));

  useEffect(() => {
    const hostname = window.location.hostname;
    const parts = hostname.split('.');
    
    const slug = (parts.length >= 3 || parts.includes('localhost')) ? parts[0] : null;
    
    if (slug && slug !== 'www' && slug !== 'localhost') {
      const logoUrl = `/assets/favicons/${slug}-favicon.png`;
      
      const link = document.querySelector("link[rel~='icon']");
      if (link) {
        link.href = logoUrl;
      }

      document.title = `${slug.toUpperCase()} Business Portal`;
    }else{
      const logoUrl = `/assets/favicon.ico`;
      const link = document.querySelector("link[rel~='icon']");
      if (link) {
        link.href = logoUrl;
      }

      document.title = `Business Portal`;
    }
  }, []);

  const hideSidebar =
    location.pathname === "/login" ||
    location.pathname.startsWith("/receipt") ||
    location.pathname.startsWith("/transactions/anonomous") ||
    (location.pathname === "/password-update" &&
      user?.passwordUpdated == false);

  return (
    <AuthProvider>
      <div style={{ display: "flex" }}>
        {!hideSidebar && (
          <AppSidebar
            collapsed={collapsed}
            setCollapsed={setCollapsed}
            isHovered={isHovered}
            setIsHovered={setIsHovered}
          />
        )}

        <div
          style={{
            flex: 1,
            padding: "0",
            marginLeft: hideSidebar
              ? "0"
              : collapsed && !isHovered
              ? "80px"
              : "250px",
            transition: "all 0.2s ease",
          }}
        >
          <AppRoutes />

          <ToastContainer />
        </div>
      </div>
    </AuthProvider>
  );
}

export default App;
